import CountryDataService from '../../service/CountryDataService';


const initialState = {
    countries: [],
}

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async fetchCountries({commit}) {
            try {
                const resp = await CountryDataService.getAll()

                if (resp.status === 200) {
                    commit('setCountries', resp.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async saveCountry({dispatch}, payload) {
            const {country} = payload;
            try {
                const resp = await CountryDataService.put(country.id, country);
                if (resp.status === 200) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Country updated',
                            type: 'success',
                        },
                        {root: true},
                    );
                } else {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Server error saving country',
                            type: 'fail',
                        },
                        {root: true},
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
    },
    mutations: {
        setCountries(state, data) {
            state.countries = data
        },
    }
}